import React from 'react'
import {
  Box,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormLabel,
} from '@material-ui/core'
import pluralize from 'pluralize'
import { CardElement } from '@stripe/react-stripe-js'

import ButtonDialogClose from '../common/ButtonDialogClose'
import useAddPaymentMethod from '../../../hooks/useAddPaymentMethod'
import StripePaymentMethodElement from '../../checkout/StripePaymentMethodElement'
import ButtonSubmit from '../../common/ButtonSubmit'
import { isPaymentMethodRequiredForTeamPerks } from '../admin/adminUtils'
import { formatCentsToPrettyDollars } from './giftCardUtils'

const AddSubscription = ({
  teamId,
  hasDefaultPaymentMethod,
  teamPaymentCollectionMethod,
  canceled,
  totalMembers,
  submitting,
  onConfirm,
  onClose,
}) => {
  const { isCreatingPaymentMethod, handleAddPaymentMethod } = useAddPaymentMethod({
    ownerType: 'ENTERPRISE',
    referenceId: teamId,
    onSuccess: paymentMethodId => {
      onConfirm(paymentMethodId)
    },
  })

  const handleSubmit = () => {
    if (isPaymentMethodRequiredForTeamPerks(hasDefaultPaymentMethod, teamPaymentCollectionMethod)) {
      handleAddPaymentMethod()
      return
    }

    onConfirm()
  }

  return (
    <>
      <DialogTitle>
        {canceled ? 'Reactivate Add-On' : 'Add-On Information'}
        <ButtonDialogClose onClick={onClose} />
      </DialogTitle>
      <DialogContent>
        {isPaymentMethodRequiredForTeamPerks(
          hasDefaultPaymentMethod,
          teamPaymentCollectionMethod,
        ) && (
          <Box mb={3}>
            <FormLabel htmlFor="credit-card">Payment method</FormLabel>
            <StripePaymentMethodElement id="credit-card" CardElement={CardElement} />
          </Box>
        )}
        <DialogContentText color="secondary">
          You&apos;ll be charged $5.99 per member, per month, prorated to the first of the month.
        </DialogContentText>
        <DialogContentText color="secondary" style={{ float: 'left', paddingTop: '2em' }}>
          {totalMembers} {pluralize('members', totalMembers)} on a monthly plan
        </DialogContentText>
        <DialogContentText color="secondary" style={{ textAlign: 'right', paddingTop: '2em' }}>
          $5.99 per member / mo
        </DialogContentText>
        <Divider />
        <DialogContentText
          color="secondary"
          style={{ float: 'left', paddingTop: '0.5em', fontSize: 'large' }}
        >
          Total
        </DialogContentText>
        <DialogContentText
          color="secondary"
          style={{ textAlign: 'right', paddingTop: '0.5em', fontSize: 'large' }}
        >
          {formatCentsToPrettyDollars(599 * totalMembers)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ButtonSubmit
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          submitting={submitting || isCreatingPaymentMethod}
        >
          Confirm
        </ButtonSubmit>
      </DialogActions>
    </>
  )
}

export default AddSubscription
